import { Line } from './styles/line-loader.styles'

const LineLoader = () => {
  return (
    <Line>
      <div className="loader-element"></div>
    </Line>
  )
}

export default LineLoader
